<template>
  <v-app :style="'background-color:' + _backgroudcolor">
    <v-content>
      <v-layout mt-2 row wrap align-center justify-center>
        <v-flex sm4 md7 lg7 pl-5>
          <v-card class="mx-auto elevation-0" outlined color="transparent">
            <v-card-title>
              <v-avatar :color="_pageDetailcolor">
                <v-icon dark>mdi-image-edit</v-icon>
              </v-avatar>
              <h4
                class="ml-2"
                :style="'font-size: 18px; color:' + _pageDetailcolor"
              >
                {{ $t("portaltoolbar.setting_logo") }}
              </h4>
            </v-card-title>
          </v-card>
        </v-flex>
        <v-flex sm8 md5 lg5 text-right pr-10>
          <DialogTestSystem></DialogTestSystem>
        </v-flex>
      </v-layout>

      <v-container grid-list-lg fluid class="mt-n2">
        <v-form ref="forms">
          <v-layout row wrap>
            <v-flex lg12 pl-4 pr-4 pb-2>
              <v-card class="elevation-0" rounded>
                <v-card-text style="font-size: 20px; color: black">
                  <br />
                  <v-layout row wrap justify-center align-center>
                    <v-flex xs10 lg10 class="boder-upload text-center">
                      <div v-if="!uploaded" class="text-center pt-4">
                        <img
                          v-if="logo != null"
                          class="uploaded d-inline-block mt-2"
                          width="200"
                          :src="'data:' + logoType + ';base64,' + logo"
                          style="border-radius: 10px"
                        />
                        <img
                          v-if="logo == null"
                          width="150"
                          style="cursor: pointer"
                          src="@/assets/photo.png"
                        />
                        <h2
                          class="mt-7"
                          style="color: #2e394f"
                          @click="triggerUpload()"
                        >
                          <span style="cursor: pointer">
                            {{ $t("settingLogo.condition.click_upload") }}</span
                          >
                        </h2>
                        <div style="font-size: 14px" class="red--text mt-5">
                          {{ $t("settingLogo.condition.limit_image") }}
                        </div>
                        <input
                          id="imageUpload"
                          ref="input"
                          class="mt-3 d-none"
                          type="file"
                          name="image"
                          accept="image/png, image/jpeg, image/jpg"
                          @change="fn_setImage"
                        />
                      </div>

                      <!-- <v-file-input
                        :rules="rules"
                        show-size
                        accept="image/png, image/jpeg, image/bmp"
                        placeholder="กรุณาเลือกรูปที่ต้องอัปโหลด"
                        prepend-icon="mdi-camera"
                        v-model="imageUpload"
                        dense
                      ></v-file-input> -->

                      <div v-if="uploaded" class="text-center pt-5">
                        <div class="uploaded d-inline-block mt-2">
                          <img
                            :src="imgSrc"
                            width="200"
                            alt="Cropped Image"
                            style="border-radius: 10px"
                          />
                        </div>
                        <h3 class="mt-5" style="color: #2e394f">
                          {{ $t("settingLogo.condition.preview_image") }}
                        </h3>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-card-text>
                <v-card-text>
                  <v-layout row wrap>
                    <v-flex xs1 md1 lg1></v-flex>
                    <v-flex xs10 md10 lg10>
                      <h3 class="red--text">
                        {{ $t("settingLogo.condition.note") }}
                      </h3>
                    </v-flex>
                  </v-layout>
                </v-card-text>
                <v-card-actions class="pa-4 mb-2">
                  <v-layout row wrap justify-center align-center>
                    <!--<v-spacer></v-spacer>-->
                    <v-flex xs4 sm3 md2 lg2>
                      <v-btn color="#f05c5a" outlined @click="fn_cancle" block>
                        {{ $t("settingLogo.condition.btnCancle") }}</v-btn
                      >
                    </v-flex>
                    <v-flex xs3 sm3 md2 lg2>
                      <v-btn
                        :loading="loadingSave"
                        dark
                        :color="_pageDetailcolor"
                        @click="fn_save"
                        block
                        >{{ $t("settingLogo.condition.btnSave") }}</v-btn
                      >
                    </v-flex>
                  </v-layout>
                  <br />
                </v-card-actions>
              </v-card>
            </v-flex>
          </v-layout>
        </v-form>
        <v-dialog v-model="modal_upload" width="800" persistent scrollable>
          <v-card>
            <v-card-text>
              <div class="img-cropper pt-6">
                <img :src="imgSrc" id="modalpreviewImg" class="uploadImg" />
              </div>
            </v-card-text>
            <v-card-actions>
              <v-layout row wrap justify-end align-end pa-2>
                <v-flex xs2 md2 lg2 mr-4>
                  <v-btn block outlined color="error" @click="fn_cancle">
                    {{ $t("settingLogo.condition.btnCancle") }}</v-btn
                  >
                </v-flex>
                <v-flex xs2 md2 lg2 mr-3>
                  <v-btn color="success" block @click="submitData()">
                    {{ $t("settingLogo.condition.btnConfirm") }}</v-btn
                  >
                </v-flex>
              </v-layout>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import authorization from "@/authorization/authorization.js";
import DialogTestSystem from "@/components/portal/dialog/dialog-test-system";
import "cropperjs/dist/cropper.css";
import swal from "sweetalert2";
// import VueCropper from "vue-cropperjs";
import { mapGetters, mapState } from "vuex";
export default {
  components: {
    DialogTestSystem,
    // VueCropper,
  },
  data: () => ({
    logo: null,
    rules: [
      (value) =>
        !value || value.size < 50000 || "รูปภาพควรมีขนาดควรน้อยกว่า 50 KB",
    ],
    imageUpload: null,
    loadingImg: false,
    file: null,
    overlay: true,
    modal_upload: false,
    uploaded: false,
    imgSrc: "",
    cropdata: null,
    loadingSave: false,
    logoType: "png",
  }),

  mounted() {
    this.fn_getLogo();
  },
  methods: {
    async fn_getLogo() {
      this.loadingImg = true;
      this.uploaded = false;
      let payload = {
        SellerID: localStorage.etax_sellerid,
        BranchID: "00000",
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var headers = await authorization.encodeHeaderNew();
      this.axios
        .post(
          process.env.VUE_APP_SERVICE_SIGNING_API + "Logo/Download",
          { Data: dataEncode },
          { headers }
        )
        .then((res) => {
          if (res.status == 200) {
            this.loadingImg = false;
            this.logo = res.data.Message.img;
            this.imgSrc = "data:image/png;base64," + this.logo;
            this.logoType = res.data.Message.type;
          }
        });
    },
    async fn_save() {
      if (this.$refs.forms.validate()) {
        this.loadingSave = true;
        let payload = {
          Logo: this.imgSrc,
          SellerID: localStorage.etax_sellerid,
          BranchID: "00000",
        };
        var dataEncode = await authorization.encodeDataNew(payload);
        var headers = await authorization.encodeHeaderNew();
        this.axios
          .post(
            process.env.VUE_APP_SERVICE_SIGNING_API + "Logo/Upload",
            { Data: dataEncode },
            { headers }
          )
          .then((res) => {
            this.loadingSave = false;
            if (res.data.Status === "OK") {
              this.imageUpload = null;
              this.imgSrc = "";
              this.file = null;
              swal.fire(this.$t("alert.success"), res.data.Message, "success");
              this.fn_getLogo();
            } else {
              swal.fire(this.$t("alert.fail"), res.data.ErrorMessage, "error");
            }
          })
          .catch((error) => {
            this.loadingSave = false;
            swal.fire(
              this.$t("alert.fail"),
              error.response.data.ErrorMessage,
              "error"
            );
          });
      }
    },
    fn_cancle() {
      this.imageUpload = [];
      this.file = null;
      this.modal_upload = false;
      this.uploaded = false;
      this.imgSrc = "";
    },
    triggerUpload() {
      this.uploaded = false;
      document.getElementById("imageUpload").value = "";
      document.getElementById("imageUpload").click();
    },
    fn_setImage(e) {
      this.file = e.target.files[0];
      const validImageTypes = ["image/jpeg", "image/png", "image/jpg"];
      if (this.file) {
        if (!validImageTypes.includes(this.file.type)) {
          swal.fire(
            this.$t("settingLogo.swal.selectFile"),
            this.$t("settingLogo.swal.typeFile"),
            "warning"
          );

          return;
        } else if (this.file.size > 51200) {
          swal.fire(
            this.$t("settingLogo.swal.selectFile"),
            this.$t("settingLogo.swal.limitFile"),
            "warning"
          );
          return;
        }
        if (typeof FileReader === "function") {
          this.modal_upload = true;
          const reader = new FileReader();
          reader.onload = (event) => {
            this.imgSrc = event.target.result;
          };
          this.logoType = this.file.type;
          reader.readAsDataURL(this.file);
        } else {
          // alert("Sorry, FileReader API not supported");
          swal.fire(
            this.$t("alert.warning"),
            this.$t("settingLogo.swal.cannotFile"),
            "warning"
          );
        }
        this.overlay = false;
      }
    },
    submitData() {
      this.uploaded = true;
      this.cropdata = JSON.parse(this.cropdata);
      this.modal_upload = false;
    },
  },
  watch: {},
  computed: {
    ...mapState(["backgroudcolor", "pageDetailcolor"]),
    ...mapGetters(["getter_dataBusiness_profile"]),
    _taxId: {
      get() {
        return this.getter_dataBusiness_profile["id_card_num"];
      },
    },
    _branchId: {
      get() {
        return this.getter_dataBusiness_profile["branch_no"];
      },
    },
    _backgroudcolor: {
      get() {
        return this.backgroudcolor;
      },
    },
    _pageDetailcolor: {
      get() {
        return this.pageDetailcolor;
      },
    },
  },
};
</script>

<style scoped>
.uploaded {
  background: #8d9696;
  width: 250;
  height: 250;
  padding: 5px;
  border-radius: 10px;
}
.uploadImg {
  width: 100%;
}
.rejectTitle {
  font-weight: 500;
  font-size: 20px;
  line-height: 36px;
  text-align: center;
  color: #333333;
}
.submitButton {
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  background: linear-gradient(141.11deg, #1e90ff 0%, #000080 106.15%);
  border: #000080;
  border-radius: 6px;
}
#image-wrapper {
  background-repeat: no-repeat;
  position: relative;
}
.boder-upload {
  background-color: white;
  border-width: 3px;
  border-color: rgb(206, 204, 204);
  border-style: dashed;
  height: 360px;
  width: 600px;
}
.boder-upload:hover {
  background-color: rgba(175, 180, 175, 0.2);
}
</style>
